import { Header, Footer } from "./components";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeLanguage, setLoading } from "./actions/general";
import { useTranslation } from "react-i18next";
import { Home, Products, Users, Manufacturers, Services, About, Partners, Contact, Info, Article, Resources, OffersInitial, OffersOptions, OfferManufacturer, OfferUser, NotFound } from "./screens";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider} from "react-helmet-async";
import "./App.scss";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { hasEnPrefix } from "./utilities/helpers";

const helmetContext = {};

function ResetLoadingOnRoute() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(false));
  }, [location.pathname, dispatch]);

  return null;
}

function App() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    const syncLangFromPath = () => {
      const lang = hasEnPrefix(window.location.pathname) ? 'en' : 'bg';
      localStorage.setItem('code', lang);
      dispatch(changeLanguage(lang));
      i18n.changeLanguage(lang);
      // set <html lang>
      if (document?.documentElement) document.documentElement.lang = lang;
    };
    syncLangFromPath();
    // also re-evaluate on history navigation
    const onPop = () => syncLangFromPath();
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [dispatch, i18n]);

  const { pathname } = window.location;
  const screen = pathname.split("/")[1];
  return (
    <HelmetProvider context={helmetContext}>
      <div className={`screen ${screen}`}>
        <BrowserRouter>
          <Header />
          <ScrollToTop />
          <ResetLoadingOnRoute />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/en" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/en/about" element={<About />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/en/partners" element={<Partners />} />
            <Route path="/products-and-services" element={<Products />} />
            <Route path="/en/products-and-services" element={<Products />} />
            <Route path="/users" element={<Users />} />
            <Route path="/en/users" element={<Users />} />
            <Route path="/manufacturers" element={<Manufacturers />} />
            <Route path="/en/manufacturers" element={<Manufacturers />} />
            <Route path="/additional-services" element={<Services />} />
            <Route path="/en/additional-services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/en/contact" element={<Contact />} />
            <Route path="/info" element={<Info />} />
            <Route path="/en/info" element={<Info />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/en/resources" element={<Resources />} />

            {/* New offers entry and options */}
            <Route path="/offers" element={<OffersInitial />} />
            <Route path="/en/offers" element={<OffersInitial />} />
            {/* Legacy redirects removed per client scope */}

            <Route path="/offers-users" element={<OffersOptions />} />
            <Route path="/en/offers-users" element={<OffersOptions />} />
            <Route path="/offers-manufacturers" element={<OffersOptions />} />
            <Route path="/en/offers-manufacturers" element={<OffersOptions />} />

            <Route path="/offer-manufacturer" element={<OfferManufacturer />} />
            <Route path="/en/offer-manufacturer" element={<OfferManufacturer />} />
            <Route path="/offer-user" element={<OfferUser />} />
            <Route path="/en/offer-user" element={<OfferUser />} />

            {/* Article routes: primary slug+id, legacy id-only */}
            <Route path="/article/:slug/:id" element={<Article />} />
            <Route path="/en/article/:slug/:id" element={<Article />} />
            <Route path="/article/:id" element={<Article />} />
            <Route path="/en/article/:id" element={<Article />} />

            {/* Anything else: the SPA fallback answers 200, so render a real
                404 page that is marked noindex instead of an empty shell. */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
